import { capitalize } from "lodash";
import { memo } from "react";
import { Alert } from "react-bootstrap";
import PropTypes from 'prop-types';

/* One glyph per variant, drawn inline so each takes the colour of the alert it
   sits in rather than needing its own image. Anything unrecognised — `danger`,
   `info` — falls back to the neutral "i". */
const ICON_PATHS = {
  success: <path d="m8 12.2 2.8 2.8L16 9.4" />,
  warning: (
    <>
      <path d="M12 7.6v5" />
      <path d="M12 16.2h.01" />
    </>
  ),
  error: (
    <>
      <path d="m8.8 8.8 6.4 6.4" />
      <path d="m15.2 8.8-6.4 6.4" />
    </>
  ),
};

const FALLBACK_ICON = (
  <>
    <path d="M12 11v5.4" />
    <path d="M12 7.8h.01" />
  </>
);

const AlertBox = (props) => {
  return (
    <Alert
      show={props.alert}
      variant={props.type}
      dismissible
      transition={false}
      role="alert"
    >
      <div className="alert_img">
        {/* The ring is the circle; the glyph inside it changes with the type. */}
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="9.2" strokeWidth="1.5" />
          {ICON_PATHS[props.type] || FALLBACK_ICON}
        </svg>
      </div>
      <div className="alert_msg_contain">
        <strong>{capitalize(props.type)}!</strong>
        <span className="alert-msg">
          {props.message instanceof Function ? props.message() : props.message}
        </span>
      </div>
    </Alert>
  );
};

AlertBox.propTypes = {
  alert: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]).isRequired,
};

export default memo(AlertBox);
